//containerGeneral.jsx
export class DatosVisor{
    constructor(codigoSeccion, codigoVisor, key, urlVisorEmbedido){
        this.codigoSeccion = codigoSeccion;
        this.codigoVisor = codigoVisor;
        this.key = key;
        this.urlVisorEmbedido = urlVisorEmbedido;
    }
}
export class ActionDatosVisor{
    constructor(codigoSeccion, codigoVisor, urlVisorEmbedido = null){
        this.payload = { codigoSeccion, codigoVisor, urlVisorEmbedido };
    }
}

//visor.jsx:
export class EstadosWidgets{
    static propCercaCambio = "cercaCambio";
    static propInfoLayerCambio = "infoLayerCambio";
    static propIdLayerClearEnFiltro = "idLayerClearEnFiltro";
    constructor(cercaCambio, cercaListaResumen, idLayerClearEnFiltro){
        this.cercaCambio = cercaCambio;
        this.cercaListaResumen = cercaListaResumen;
        this.idLayerClearEnFiltro = idLayerClearEnFiltro;
    }
}
export class ActionEstadosWidgets {
    static tipoCambiarValor = "tipoCambiarValor";
    static tipoInvertirValor = "tipoInvertirValor";
    constructor(type, propEstadosWidgets){
        this.type = type;
        this.payload = { propEstadosWidgets };
    }
}
export class ActionEstadosWidgetsCambiarValor extends ActionEstadosWidgets {
    constructor(propEstadosWidgets, valor){
        super(ActionEstadosWidgets.tipoCambiarValor, propEstadosWidgets);
        this.payload.valor = valor;
    }
}
export class ActionEstadosWidgetsInvertirValor extends ActionEstadosWidgets {
    constructor(propEstadosWidgets){
        super(ActionEstadosWidgets.tipoInvertirValor, propEstadosWidgets);
    }
}

export class ListaResumenCapa {
    constructor (idLayer, expressionInfo, campoOrden = null, campoAgrupacion = null, zoomParaPunto = null, lista = null) {
        this.idLayer = idLayer;
        this.expressionInfo = expressionInfo;
        this.campoOrden = campoOrden;
        this.campoAgrupacion = campoAgrupacion;
        this.zoomParaPunto = zoomParaPunto;
        this.lista = lista;
    }
}
export class ElementoListaResumenCapa {
    static tipoAgrupacion = "tipoAgrupacion";
    static tipoGraphic = "tipoGraphic";
    constructor(tipo, resaltado){
        this.tipo = tipo;
        this.resaltado = resaltado;
    }
}
export class ElementoListaResumenCapaAgrupacion extends ElementoListaResumenCapa {
    constructor(valor, indexIni, indexFin = null, desplegado = false, resaltado = false){
        super(ElementoListaResumenCapa.tipoAgrupacion, resaltado);
        this.valor = valor;
        this.indexIni = indexIni;
        this.indexFin = indexFin;
        this.desplegado = desplegado;
    }
}
export class ElementoListaResumenCapaGraphic extends ElementoListaResumenCapa {
    static propGraphic = "graphic";
    static propIdRegistro = "idRegistro";
    constructor(visible, resaltado, graphic, idRegistro){
        super(ElementoListaResumenCapa.tipoGraphic, resaltado);
        this.visible = visible;
        this.graphic = graphic;
        this.idRegistro = idRegistro;
    }
}

export class ActionListaResumenCerca {
    static tipoCambiarListaResumen = "tipoCambiarListaResumen";
    static tipoResaltarElemento = "tipoResaltarElemento";
    static tipoRemoveAllResaltados = "tipoRemoveAllResaltados";
    static tipoCambiarVisibilidadGrupo = "tipoCambiarVisibilidadGrupo";
    constructor(type){
        this.type = type;
    }
}
export class ActionListaResumenCercaCambiarListaResumen extends ActionListaResumenCerca {
    constructor(nuevaListaResumen){
        super(ActionListaResumenCerca.tipoCambiarListaResumen);
        this.payload = nuevaListaResumen;
    }
}
export class ActionListaResumenCercaResaltarElemento extends ActionListaResumenCerca {
    constructor(indexElemento){
        super(ActionListaResumenCerca.tipoResaltarElemento);
        this.payload = indexElemento;
    }
}
export class ActionListaResumenCercaRemoveAllResaltados extends ActionListaResumenCerca {
    constructor(){
        super(ActionListaResumenCerca.tipoRemoveAllResaltados);
        this.payload = null;
    }
}
export class ActionListaResumenCercaCambiarVisibilidadGrupo extends ActionListaResumenCerca {
    constructor(visible, indexElementoAgrupacion){
        super(ActionListaResumenCerca.tipoCambiarVisibilidadGrupo);
        this.payload = { visible, indexElementoAgrupacion};
    }
}